import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Stethoscope, Building2, FlaskConical, Hospital } from "lucide-react";

const TargetAudience: React.FC = () => {
  return (
    <section className="py-8 md:py-16 bg-white px-4 md:px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-6 md:mb-14">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            A TAX HEALTH TE ATENDE
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Focada na área da saúde
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Soluções tributárias especializadas para diferentes perfis do setor de saúde
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
          <TargetCard 
            icon={<Stethoscope className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Médicos"
            description="A Tax Health ajuda médicos a economizar dinheiro e otimizar a gestão fiscal de suas práticas. Com nossa consultoria especializada, médicos podem reduzir impostos e investir mais em suas carreiras e cuidado aos pacientes."
          />
          
          <TargetCard 
            icon={<Building2 className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Clínicas"
            description="A Tax Health ajuda clínicas a economizar dinheiro e melhorar a gestão fiscal. Com nossa consultoria tributária, clínicas podem investir em equipamentos modernos e melhoria do atendimento."
          />
          
          <TargetCard 
            icon={<FlaskConical className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Laboratórios"
            description="A Tax Health pode economizar seu dinheiro e melhorar a gestão fiscal do seu laboratório. Com nossa consultoria especializada, você pode investir em tecnologia de ponta e expandir seus serviços."
          />
          
          <TargetCard 
            icon={<Hospital className="h-6 w-6 md:h-8 md:w-8 text-blue-500" />}
            title="Hospitais"
            description="A Tax Health ajuda hospitais a economizar dinheiro e otimizar a gestão fiscal. Nossa consultoria permite que hospitais invistam em infraestrutura, equipamentos e melhoria do atendimento aos pacientes."
          />
        </div>
      </div>
    </section>
  );
};

interface TargetCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const TargetCard: React.FC<TargetCardProps> = ({ icon, title, description }) => {
  return (
    <Card className="transition-all duration-300 hover:shadow-md h-full border-none shadow-sm bg-blue-50 bg-opacity-50">
      <CardContent className="p-3 md:p-6">
        <div className="flex flex-col h-full">
          <div className="flex items-start gap-4 mb-3">
            <div className="flex-shrink-0 p-2 md:p-3 bg-white rounded-full shadow-sm">
              {icon}
            </div>
            <h3 className="text-lg md:text-xl font-semibold text-gray-900 pt-2">{title}</h3>
          </div>
          <p className="text-sm md:text-base text-gray-600">{description}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default TargetAudience;
